import {useState} from 'react';
import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
  Separator,
} from '@chekin/guestapp-ui-kit';
import {ChevronDownIcon, ChevronUpIcon, LifeBuoy} from 'lucide-react';
import {Trans, useTranslation} from 'react-i18next';
import cn from 'clsx';

type Props = {
  className?: string;
};
export const NeedHelp = ({className}: Props) => {
  const [open, setOpen] = useState(false);
  const {t} = useTranslation();

  return (
    <div
      className={cn(
        className,
        'flex flex-col bg-white rounded-2xl border border-gray-200 text-sm',
      )}
    >
      <div className="flex flex-col gap-2 leading-6 p-4">
        <h2 className="flex items-center gap-2 text-lg font-semibold">
          <LifeBuoy size={20} /> {t('esim.my.need_help')}
        </h2>
        <div>
          <Trans
            i18nKey={'esim.my.contact_airalo'}
            components={{
              EmailComponent: (
                <a
                  className="text-[var(--primary)] underline"
                  href="mailto:support@airalo.com"
                ></a>
              ),
            }}
          />
        </div>
      </div>

      <Separator className="w-full" />

      <Collapsible
        open={open}
        onOpenChange={setOpen}
        className="flex flex-col gap-4 p-4 items-start"
      >
        <CollapsibleTrigger className="flex items-center justify-start gap-2 text-[var(--primary)] [--lucide-stroke-width:3]">
          <span className="text-sm font-semibold">
            {t('esim.my.common_issues_title')}
          </span>
          {open ? <ChevronUpIcon size={16} /> : <ChevronDownIcon size={16} />}
        </CollapsibleTrigger>
        <CollapsibleContent>
          <ul className="list-disc list-inside text-sm leading-6">
            <li className="marker:text-[0.8rem]">
              <Trans i18nKey="esim.my.issue_activating" />
            </li>
            <li className="marker:text-[0.8rem]">
              <Trans i18nKey="esim.my.issue_no_internet" />
            </li>
            <li className="marker:text-[0.8rem]">
              <Trans i18nKey="esim.my.issue_installation_failed" />
            </li>
            <li className="marker:text-[0.8rem]">
              <Trans i18nKey="esim.my.issue_data_not_working" />
            </li>
          </ul>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};
